export class HttpBodyRespModel<T = any> {
	public count: number;
	public message: string;
	public data: T;
	public status: number;
	public totalRecord;

	public convert(dto: Record<string, any>): HttpBodyRespModel {
		// Some endpoints (e.g. getAdminShiftCat) return a bare array instead of the
		// {data, totalRecord} envelope. Treat the array as the data; count = its length.
		// ponytail: no server total on these, so pagination assumes the array is the full set.
		if (Array.isArray(dto)) {
			this.data = dto as any;
			this.count = dto.length;
			return this;
		}

		this.count = dto.totalRecord;
		this.message = dto.message;
		// Some endpoints leak a Spring ResponseEntity ({headers, body, statusCode}) instead of the
		// {data} envelope; the real payload is then under `body`. Fall back to it when `data` is absent.
		this.data = dto.data !== undefined ? dto.data : dto.body;
		this.status = dto.status;

		return this;
	}
}
